export const COMPONENT_PUBLISH_REQUESTED = 'component/PUBLISH_REQUESTED';
export const COMPONENT_PUBLISH_SUCCESS = 'component/PUBLISH_SUCCESS';
export const COMPONENT_PUBLISH_REJECTED = 'component/PUBLISH_REJECTED';
